import { motion, useAnimationControls } from "framer-motion";
import { useEffect } from "react";

const TOKENS = [
  "ISO 9001", "Calidad", "ISO 14001", "Ambiente", "ISO/IEC 27001",
  "Seguridad de la información", "FSC", "Cadena de custodia",
  "INTE G38", "Bandera Azul Ecológica", "Sostenibilidad", "Mejora continua",
];

export default function Marquee() {
  const controls = useAnimationControls();

  useEffect(() => {
    controls.start({ x: ["0%", "-50%"], transition: { duration: 50, ease: "linear", repeat: Infinity } });
  }, [controls]);

  const doubled = [...TOKENS, ...TOKENS];

  return (
    <section aria-label="Editorial marquee" className="relative py-10 md:py-14 border-y border-[#1A1A1A]/10 overflow-clip" data-testid="marquee-section">
      <motion.div className="marquee-track whitespace-nowrap" animate={controls}>
        {doubled.map((t, i) => (
          <span key={i} className="inline-flex items-center gap-8 pr-8">
            <span className="font-serif italic text-[clamp(2.25rem,7vw,5.5rem)] leading-none text-[#1A1A1A]">
              {t}
            </span>
            <span className="text-[#1B3B2B]">◆</span>
          </span>
        ))}
      </motion.div>
    </section>
  );
}
